<template lang="pug">
  b-container
    b-button.float-right(variant="soft-secondary", :to="{name: 'Account agents', params: {account_id: $route.params.account_id} }")
      .d-flex.align-items-center
        arrow-left-icon.icon-md.mr-2
        span Volver a agentes
    .header.mb-0.mt-0
      .header-body
        .d-flex.align-items-center
          Avatar(style="width: fit-content;", :size="'lg'", :src="admin.image || ''")
          .ml-3
            h6.header-pretitle.mb-0 {{ admin.first_name }} {{admin.last_name}}
            .text-secondary {{admin.email}}
    date-range-picker.w-100.p-0.my-2(v-bind="calendar_props", v-model="picked_date", :maxDate="$moment().add(1, 'days').format('YYYY-MM-DD')", @update="datePicked")
      template(v-slot:input="picker", style="width:100%;")
        b-input-group
          b-form-input.readonly-white(placeholder="Seleccionar fecha...", :value="selected_dates", readonly)
          b-input-group-append
            b-input-group-text
              calendar-icon.text-secondary.icon-md
    b-row.mb-2.align-items-center
      b-col.order-md-2(md="5")
        b-card.mb-0.no-shadow
          h5.mb-3 Sessión de agente
          div(v-if="sessions_duration.length")
            p.text-secondary(v-for="session in sessions_duration", :key="session.value") {{session.title}}: {{session.time_format}}
            p.text-secondary Última conexión: {{$moment(admin.last_login).format('LL - hh:mm A')}}
          p.text-secondary(v-else) No hay datos en estas fechas
      b-col.order-md-2(md="7")
        empty-message(message="No hay datos en estas fechas", v-if="!sessions_duration.length")
        canvas#duration-chart
    empty-message(message="No hay datos en estas fechas", v-if="!sessions.length")
    canvas#session-chart
</template>

<script>
import {createNamespacedHelpers, mapActions} from 'vuex'
import Avatar from '../../components/Avatar.vue'
import Chart from 'chart.js';
import 'chartjs-plugin-datalabels'
import Days from '@/data/days'
import Months from '@/data/months'
const accountController = createNamespacedHelpers('account')

export default {
  data () {
    return {
      loading: false,
      admin: {},
      admin_statuses: [
        {
          title: 'Disponible',
          variant: 'soft-success',
          color: '#00d97e',
          value: 'available'
        },
        {
          title: 'Pausa administrativa',
          color: '#f6c343',
          value: 'backoffice'
        },
        {
          title: 'Descanso',
          color: '#39afd1',
          value: 'break'
        },
        {
          title: 'Desconectado',
          color: '#6e84a3',
          value: 'offline'
        }
      ],
      pie_chart: null,
      sessions_chart: null,
      calendar_props: {
        timePicker: true,
        ranges: false,
        linkedCalendars: false,
        opens: 'right',
        localeData: {
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          daysOfWeek: Days.daysShort,
          monthNames: Months.monthsShort,
          firstDay: 0
        }
      },
      picked_date: {
        startDate: null,
        endDate: null
      },
    }
  },
  computed: {
    ...accountController.mapState({
      account: state => state.account,
      admins: state => state.admins
    }),
    sessions_duration () {
      let self = this

      return this.admin.sessions_duration ? this.admin.sessions_duration.filter(s => s.name != 'default' && s.name != 'offline').map(s => {
        let status = self.admin_statuses.find(a_s => a_s.value == s.name)
        s.title = status ? status.title : s.name.capitalize()
        s.color = status ? status.color : '#4a5dff'
        return s
      }) : []
    },
    sessions () {
      let self = this
      return this.admin.sessions.filter(s => s.status != 'default' && s.status != 'offline').map(s => {
        let status = self.admin_statuses.find(a_s => a_s.value == s.status)
        s.title = status ? status.title : s.status.capitalize()
        s.color = status ? status.color : '#4a5dff'
        return s
      })
    },
    selected_dates () {
      if(!this.picked_date.startDate || !this.picked_date.endDate) return ''
      return this.$moment(this.picked_date.startDate).format('DD MMM YYYY - hh:mm A') + ' - ' + this.$moment(this.picked_date.endDate).format('DD MMM YYYY - hh:mm A')
    },
  },
  methods: {
    ...mapActions(['admin/sessions']),
    getSessions () {
      let self = this
      this.showLoadingScreen()

      this['admin/sessions']({
        admin_id: self.$route.params.admin_id,
        params: {
          startDate: self.picked_date.startDate,
          endDate: self.picked_date.endDate
        },
        callback: res => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.admin = res.resource
            self.$nextTick(() => {
              if(this.sessions_duration.length)
                self.createPieChart()
              if(self.sessions.length)
                self.createSessionsChart()
            })
          }
        }
      })
    },
    async createPieChart () {
      let self = this
      this.pie_chart = await this.createChart({
        ctx: document.getElementById('duration-chart').getContext('2d'),
        type: 'doughnut',
        labels: this.sessions_duration.map(s => s.title),
        datasets: [{
          data: this.sessions_duration.map(s => s.duration),
          backgroundColor: this.sessions_duration.map(s => s.color),
          borderWidth: 1
        }],
        options: {
          responsive: true,
          maintainAspectRatio: true,
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                let label = self.sessions_duration.find(s => s.title == data.labels[tooltipItem.index])
                return label ? `${label.title} ${label.time_format}` : data.datasets[tooltipItem.datasetIndex].label;
              }
            }
          },
          plugins: {
            datalabels: {
              display: false,
            }
          }
        },
      })
    },
    async createSessionsChart () {
      let self = this
      this.sessions_chart = await this.createChart({
        ctx: document.getElementById('session-chart').getContext("2d"),
        type: 'line',
        labels: this.sessions.map(s => self.$moment(s.start_time).format('DD MMM')),
        datasets: [{
          label: this.sessions.map(s => s.admin_session_id),
          borderColor: this.sessions.map(s => s.color),
          data: this.sessions.map(s => s.duration),
          pointBackgroundColor: this.sessions.map(s => s.color),
          pointRadius: 6,
          pointHoverRadius: 8,
        }],
        options: {
          cornerRadius: 7,
          fullCornerRadius: false,
          responsive: true,
          maintainAspectRatio: true,
          legend: {
            display: false
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                let session_id = data.datasets[tooltipItem.datasetIndex].label[tooltipItem.index]
                let label = self.sessions.find(s => s.admin_session_id == session_id)
                return label ? [label.title + ': ' + label.time_format, self.$moment(label.start_time).format('[De] DD MMM YYYY hh:mm A') + self.$moment(label.end_time).format('[ a] DD MMM YYYY hh:mm A')] : data.labels[tooltipItem.index]
              }
            }
          },
          layout: {
            padding: {
              top: 30,
              right: 0,
              bottom: 0,
              left: 0
            }
          },
          elements: {
            line: {
              fill: false
            }
          },
          scales: {
            yAxes: [{
              ticks: {
                callback: function(value, index, values) {
                  return  self.$moment.duration(value, 'seconds').humanize()
                }
              }
            }],
          },
          plugins: {
            datalabels: {
              display: false,
              anchor: 'end',
              align: 'end',
              offset: 3,
              color: '#404040',

              formatter: function(value, context) {
                let session_id = context.dataset.label[context.dataIndex]
                let label = self.sessions.find(s => s.admin_session_id == session_id)
                return label ? label.time_format : ''
              }
            }
          }
        }
      })
    },
    createChart ({ctx, type, labels, datasets, options}) {
      return new Chart(ctx, {
        type: type,
        data: {
          labels: labels,
          datasets: datasets
        },
        options: options
      });
    },
    datePicked () {
      if(this.pie_chart) this.pie_chart.destroy()
      if(this.sessions_chart) this.sessions_chart.destroy()
      this.getSessions()
    },
  },
  mounted () {
    this.picked_date.startDate = this.$moment().subtract(1, 'months').startOf('day').format()
    this.picked_date.endDate = this.$moment().endOf('day').format()
    this.getSessions()
  },
  components: { Avatar }
}
</script>

<style lang="scss" scoped>
</style>
